/**
 * What the code outside the screens says to the cashier: the store's answers
 * about a sale, a shift and the drawer, the offline queue, the loss-control
 * notice, the re-price toast and the scale label's warnings. The owner's
 * modules keep their own messages until their slice.
 */
export const lib = {
  'removal.after': 'ჩაიწერა: ამოღება გადახდის ფანჯრის შემდეგ',
  'removal.afterDesc': 'მფლობელს ეს ცალკე ეჩვენება',
  'removal.done': 'კალათიდან ამოღება ჩაიწერა',
  'removal.doneDesc': 'მფლობელი ხედავს, რა ამოიღეს კალათიდან',

  'reprice.line': '„{name}" {from} → {to}',
  'reprice.more': '{head} და კიდევ {n}',

  'scale.zeroWeight': 'წონა 0 იყო ეტიკეტზე — რაოდენობა გადაამოწმე',
  'scale.noPrice': 'ფასი არ არის მითითებული — რაოდენობა გადაამოწმე',
  'scale.zeroPrice': 'ეტიკეტის ფასი 0 იყო — რაოდენობა გადაამოწმე',

  'store.synced': '✓ {n} offline გაყიდვა დასინქრონდა',
  'store.syncedPartial': '✓ {n} გაყიდვა დასინქრონდა, {left} ელოდება',
  'store.syncFailed': '{n} გაყიდვის სინქრონი ვერ მოხერხდა — თავიდან ცდისთვის დააჭირე ბანერს',
  'store.offlineMode': '📴 Offline რეჟიმი — ნაჩვენებია ბოლო შენახული მონაცემები',
  'store.loadFailed': 'მონაცემების ჩატვირთვა ვერ მოხერხდა',

  'store.bonusOffline': 'ბონუსით გადახდა offline რეჟიმში მიუწვდომელია',
  // 1.58 — price groups and the box
  'store.groupOffline': 'ჯგუფის ფასს ინტერნეტი სჭირდება — მოხსენით მყიდველი ან დაელოდეთ კავშირს. კალათა დარჩა.',
  'store.priceGroupFailed': 'ფასის ჯგუფი ვერ შეინახა',
  'store.packPrice': 'ყუთის ფასი ცალების ჯამზე ნაკლები უნდა იყოს',
  'store.packQty': 'ყუთში ცალების რაოდენობა 2-დან 10 000-მდე უნდა იყოს',
  'store.packKind': 'ყუთი მხოლოდ ცალობით გასაყიდ პროდუქტს შეიძლება ჰქონდეს (არა წონითს, მომსახურებას ან სერიულნომრიანს)',
  'store.packCodeTaken': 'ეს შტრიხკოდი სხვა პროდუქტს ეკუთვნის',
  'store.packCodeOwn': 'ყუთის კოდი ცალის კოდისგან განსხვავებული უნდა იყოს',
  'store.packCodeInvalid': 'ყუთის შტრიხკოდი არასწორია',
  'store.packOwnerOnly': 'ყუთს მხოლოდ მფლობელი ცვლის',
  'store.packFailed': 'ყუთი ვერ შეინახა',
  'store.creditNeedsCustomer': 'ნისიას კლიენტი სჭირდება',
  'store.savedOffline': '📴 გაყიდვა შენახულია ლოკალურად — დასინქრონდება ინტერნეტის დაბრუნებისას',
  'store.offlineSaveFailed': 'გაყიდვა ვერ შეინახა: ამ მოწყობილობის მეხსიერება სავსეა ან დაბლოკილია. კალათა დარჩა — როცა ინტერნეტი დაბრუნდება, გაყიდვა თავიდან სცადე.',
  'store.insufficient': '{name} — მარაგში მხოლოდ {n} დარჩა',
  'store.priceChanged': '„{name}"-ის ფასი შეიცვალა: {from} → {to} — კალათა განახლდა, დააჭირე გაყიდვას თავიდან',
  'store.ownerPinLocked': 'მფლობელის PIN დაიბლოკა — ზედმეტად ბევრი არასწორი ცდა. სცადე 15 წუთში',
  'store.discountLimit': 'ამ მოლარის ფასდაკლების ლიმიტი {limit}%-ია — მეტს მფლობელის PIN სჭირდება',
  'store.bonusInsufficient': 'კლიენტს ბონუსი მხოლოდ {sum} აქვს — განაახლე და სცადე თავიდან',
  'store.promoChanged': 'აქცია „{name}" შეიცვალა ან დასრულდა — კალათა განახლდა, სცადე თავიდან',
  'store.bonusDisabled': 'ბონუსი ამ მაღაზიაში გამორთულია — პარამეტრები → ლოიალობა',
  'store.saleFailed': 'გაყიდვის შენახვა ვერ მოხერხდა',
  'store.ownerPinWrong': 'მფლობელის PIN არასწორია — გაყიდვა არ ჩაიწერა',
  'store.holdFailed': 'კალათის გადადება ვერ მოხერხდა',
  'store.heldDeleteFailed': 'გადადებული კალათის წაშლა ვერ მოხერხდა',

  'store.pinLocked': 'ზედმეტად ბევრი არასწორი PIN — ცვლის გახსნა დაიბლოკა. სცადე 15 წუთში',
  'store.shiftAlreadyOpen': 'ცვლა უკვე გახსნილია',
  'store.cashierWrongBranch': 'ეს მოლარე სხვა ფილიალისაა',
  'store.shiftWaiterForbidden': 'ეს მიმტანის PIN-ია — ცვლას მოლარის PIN ხსნის',
  'store.cashierOpenAt': 'ამ მოლარეს ცვლა უკვე ღია აქვს ფილიალში „{where}“ — ჯერ იქ დახურეთ',
  'store.cashierOpenElsewhere': 'ამ მოლარეს ცვლა უკვე ღია აქვს სხვა ფილიალში — ჯერ იქ დახურეთ',
  'store.openFailed': 'ცვლის გახსნა ვერ მოხერხდა',
  'store.pinWrong': 'PIN არასწორია ან მოლარე გათიშულია',
  'store.closeFailed': 'ცვლის დახურვა ვერ მოხერხდა',
  'store.closeReason': 'აირჩიე, სად წავიდა გატანილი თანხა',
  'store.noteTooLong': 'შენიშვნა ძალიან გრძელია — მაქსიმუმ 200 სიმბოლო',
  'store.bankInvalid': 'აირჩიე ბანკი — TBC, BOG ან Liberty',
  'store.shiftRequired': 'ცვლა დახურულია — ჯერ გახსენი ცვლა',
  'store.drawerOffline': 'ინტერნეტი არ არის — სალაროს მოძრაობა მხოლოდ ინტერნეტით იწერება',
  'store.drawerFailed': 'სალაროს მოძრაობა ვერ ჩაიწერა',
  'store.drawerDeleteFailed': 'ჩანაწერის წაშლა ვერ მოხერხდა',
  'store.drawer.amount': 'თანხა არასწორია — 0-ზე მეტი, მაქსიმუმ ₾100 000, თეთრი ორი ციფრით',
  'store.drawer.note': '„სხვა" მიზეზს შენიშვნა სჭირდება — დაწერე, რისთვის',
  'store.drawer.reason': 'ეს მიზეზი ამ მიმართულებას არ ერგება — აირჩიე ხელახლა',
  'store.drawer.category': 'ხარჯის კატეგორია არასწორია — აირჩიე ხელახლა',
  'store.drawer.shiftNotFound': 'ცვლა ვერ მოიძებნა — გვერდი განაახლე',
  'store.drawer.shiftClosed': 'ეს ცვლა უკვე დახურულია — დახურული ცვლის სალარო აღარ იცვლება',
  'store.drawer.gone': 'ეს ჩანაწერი უკვე წაშლილია',
  'store.drawer.notYours': 'ამ ჩანაწერს მხოლოდ მფლობელი ან მისი ჩამწერი წაშლის',

  'store.refusal.returnExceeds': 'ეს გაყიდვა (ან მისი ნაწილი) უკვე დაბრუნებულია — გვერდი განაახლე და ნახე რა დარჩა',
  'store.refusal.shiftClosed': 'ეს ცვლა უკვე დახურულია — გვერდი განაახლე',
  'store.refusal.returnOriginal': 'ორიგინალი გაყიდვა ვერ მოიძებნა — გვერდი განაახლე',
  'store.refusal.orgInactive': 'ანგარიში შეჩერებულია — ჩაწერა ვერ მოხერხდება',
  'store.refusal.support': 'მხარდაჭერის რეჟიმში ფული, გაყიდვა და სალარო მხოლოდ მფლობელისაა',
  'store.refusal.serviceNoStock': 'მომსახურებას მარაგი არ აქვს — არც მიიღება, არც ჩამოიწერება, არც ბრუნდება მომწოდებელთან',
  'store.refusal.refReused': 'ეს უკვე სხვა მონაცემებით ჩაიწერა — განაახლე გვერდი და ნახე, რა შეინახა',
  'store.refusal.qrNotPaid': 'ეს QR ჯერ გადახდილი არ არის — გაყიდვა არ ჩაიწერა',
  'store.refusal.qrAmount': 'გადახდილი თანხა კალათის ჯამს არ ემთხვევა — გაყიდვა არ ჩაიწერა',
  'store.refusal.qrMethod': 'QR-ით გადახდილი გაყიდვა მხოლოდ „ბარათი → QR"-ით იწერება',
  'store.customerAddFailed': 'კლიენტის დამატება ვერ მოხერხდა',
  'store.customerUpdateFailed': 'კლიენტის განახლება ვერ მოხერხდა',
  'store.customerDeleteFailed': 'კლიენტის წაშლა ვერ მოხერხდა',
  'store.customerHasDebt': '{name}-ს ჯერ ვალი აქვს ({sum}) — წაშლამდე ბალანსი უნდა დაიხუროს',
  'store.customerHasCredit': '{name}-ს ჯერ ზედმეტი აქვს გადახდილი ({sum}) — წაშლამდე ბალანსი უნდა დაიხუროს',
  'store.customerHasBonus': '{name}-ს ბონუსი აქვს ({sum}) — წაშლა მას წაშლიდა. ჯერ დახარჯე ან შეასწორე.',
  'store.customerHasPayments': 'ამ კლიენტს გადახდების ისტორია აქვს — წაშლა მას წაშლიდა. კლიენტი დატოვე, უბრალოდ აღარ გამოიყენო.',
  'store.paymentFailed': 'გადახდის შენახვა ვერ მოხერხდა',
  'store.bonusOwnerOnly': 'ბონუსის შესწორება მხოლოდ მფლობელს შეუძლია',
  'store.bonusAdjustFailed': 'ბონუსის შესწორება ვერ მოხერხდა',
  'store.readOnly': 'ბუღალტრის ანგარიშით მხოლოდ ნახვაა შესაძლებელი',
  'store.supportOnlyOwner': 'მხარდაჭერის რეჟიმში ეს მხოლოდ მფლობელს შეუძლია',
  'store.x.1': 'ძველი ისტორიის ჩატვირთვა ვერ მოხერხდა',
  'store.x.2': 'კლიენტის ძველი ისტორია ვერ ჩაიტვირთა — სია შეიძლება არასრული იყოს',
  'store.x.3': 'პარამეტრების შენახვა ვერ მოხერხდა',
  'store.x.4': 'პარამეტრის შენახვა ვერ მოხერხდა',
  'store.x.5': 'PIN-ის შენახვა ვერ მოხერხდა',
  'store.x.6': 'მოთხოვნა ვერ გაიგზავნა',
  'store.x.7': 'განახლების მოთხოვნა გაიგზავნა — მალე დაგიკავშირდებით',
  'store.x.8': 'შეტყობინება ვერ გაიგზავნა',
  'store.x.9': 'ინტერნეტი არ არის — შეტყობინება ვერ გაიგზავნა',
  'store.x.10': 'კოდი ვერ შეიქმნა',
  'store.x.11': 'ინტერნეტი არ არის — მოთხოვნა ვერ გაიგზავნა',
  'store.x.12': 'წვდომის დასრულება ვერ მოხერხდა',
  'store.x.13': '„{name}" უკვე არსებობს ამ კატეგორიაში',
  'store.x.14': 'კატეგორიის დამატება ვერ მოხერხდა',
  'store.x.15': 'კატეგორიების შექმნა ვერ მოხერხდა',
  'store.x.16': '„{p1}" უკვე არსებობს ამ კატეგორიაში',
  'store.x.17': 'კატეგორიის განახლება ვერ მოხერხდა',
  'store.x.18': 'კატეგორიის წაშლა ვერ მოხერხდა',
  'store.x.19': 'პროდუქციის განახლება ვერ მოხერხდა',
  'store.x.20': 'ფილიალი: {name}',
  'store.x.21': 'ფილიალის დამატება ვერ მოხერხდა',
  'store.x.22': 'ფილიალის განახლება ვერ მოხერხდა',
  'store.x.23': 'მთავარი ფილიალის წაშლა შეუძლებელია',
  'store.x.24': 'ფილიალში ჯერ კიდევ არის მარაგი — ჯერ გადაიტანე ან ჩამოწერე',
  'store.x.25': 'გადატანების შემოწმება ვერ მოხერხდა — ფილიალი არ წაშლილა',
  'store.x.26': 'ფილიალს გადატანების ისტორია აქვს — წაშლა შეუძლებელია',
  'store.x.27': 'ფილიალის წაშლა ვერ მოხერხდა',
  'store.x.28': 'ერთსა და იმავე ფილიალში გადატანა შეუძლებელია',
  'store.x.29': 'გადატანა ვერ მოხერხდა',
  'store.x.30': 'მარაგი გადატანილია',
  'store.x.31': 'კატალოგთან კავშირი ვერ შედგა',
  'store.x.32': 'საცდელ პერიოდში მაქს. 10 000 პროდუქტია — გადახდის შემდეგ ლიმიტი აღარ არის',
  'store.x.33': 'ზოგიერთი შტრიხკოდი უკვე არსებობს — დახურე და ხელახლა გახსენი',
  'store.x.34': 'კატალოგიდან დამატება ვერ მოხერხდა',
  'store.x.35': 'ჯერ ჩართე გაზიარება',
  'store.x.36': 'კატალოგში გაზიარება ვერ მოხერხდა',
  'store.x.37': 'გამოთხოვა ვერ მოხერხდა',
  'store.x.38': 'თანმხლების შენახვა ვერ მოხერხდა',
  'store.x.39': 'წყარო და შედეგი ერთი და იგივე პროდუქტია',
  'store.x.40': 'რაოდენობა ნულზე მეტი უნდა იყოს',
  'store.x.41': 'პროდუქტი ვერ მოიძებნა',
  'store.x.42': 'დაშლა ვერ მოხერხდა',
  'store.x.43': '{source_name} დაიშალა — {target_qty} × {target_name} (₾{unit_cost}/ცალი)',
  'store.x.44': 'შტრიხკოდი {p1} სხვა პროდუქტს უკვე აქვს',
  'store.x.45': 'პროდუქტის დამატება ვერ მოხერხდა',
  'store.x.46': 'მარაგი ფილიალზე ვერ დაფიქსირდა — შეასწორე პროდუქტის ბარათიდან',
  'store.x.47': 'პროდუქტების იმპორტი ვერ მოხერხდა',
  'store.x.purchasePartial': 'ნაშთი ჩაიწერა, მაგრამ შესყიდვაში მხოლოდ {done} ხაზი ჩავიდა {total}-დან — ბუღალტერიაში ხარჯი ნაკლები ჩანს',
  'store.x.restockOwner': 'ნაშთის შევსება მხოლოდ მფლობელს შეუძლია',
  'store.x.openingFailed': 'საწყისი ნაშთი ვერ ჩაიწერა',
  'store.historyFailed': 'გაყიდვების ისტორია ვერ ჩაიტვირთა — სალარო მუშაობს, ისტორიას ბუღალტერიიდან თავიდან ცდით ჩატვირთავ',
  'store.x.48': 'ეს ზომა და ფერი ამ მოდელს უკვე აქვს — გვერდი განაახლე',
  'store.x.49': 'მოდელის შენახვა ვერ მოხერხდა',
  'store.x.50': 'მოდელის განახლება ვერ მოხერხდა',
  'store.x.51': 'ფოტოს შენახვა ვერ მოხერხდა',
  'store.x.52': 'ზოგიერთი ზომის სახელი ვერ შეიცვალა — გვერდი განაახლე',
  'store.x.53': 'მოდელის წაშლა ვერ მოხერხდა',
  'store.x.54': 'მოდელი ვერ წაიშალა — გვერდი განაახლე',
  'store.x.55': 'მარაგის განახლება ვერ მოხერხდა',
  'store.x.56': 'პროდუქტის განახლება ვერ მოხერხდა',
  'store.x.57': 'ნაშთის შევსება ვერ მოხერხდა',
  'store.x.58': 'ნაშთი არ არის საკმარისი — ჯერ ინვენტარიზაცია გააკეთე',
  'store.x.59': 'რაოდენობა არასწორია',
  'store.x.60': 'ჩამოწერა მხოლოდ მფლობელს შეუძლია',
  'store.x.61': 'ჩამოწერა ვერ მოხერხდა',
  'store.x.62': 'პროდუქტის წაშლა ვერ მოხერხდა',
  'store.x.63': 'დაბრუნების შენახვა ვერ მოხერხდა',
  'store.x.64': 'მომწოდებლის დამატება ვერ მოხერხდა',
  'store.x.65': 'მომწოდებლის განახლება ვერ მოხერხდა',
  'store.x.66': '{name}-თან ბალანსი ღიაა (₾{p1}) — წაშლამდე უნდა დაიხუროს',
  'store.x.67': 'ამ მომწოდებელს გადახდების ისტორია აქვს — წაშლა მას წაშლიდა. დატოვე, უბრალოდ აღარ გამოიყენო.',
  'store.x.supReturns': 'ამ მომწოდებელს დაბრუნებები აქვს — ისინი მაღაზიის ანგარიშებშია. დატოვე, უბრალოდ აღარ გამოიყენო.',
  'store.x.68': 'მომწოდებლის წაშლა ვერ მოხერხდა',
  'store.x.69': 'ეს ზედნადები უკვე მიღებულია საწყობში',
  'store.x.70': 'შესყიდვის შენახვა ვერ მოხერხდა',
  'store.x.lotWriteOff': 'პარტიის ჩამოწერა ვერ მოხერხდა',
  'store.x.lotEdit': 'პარტიის შესწორება ვერ მოხერხდა',
  'store.x.lotTrack': '„ვადიანი პროდუქტის“ შეცვლა ვერ მოხერხდა',
  'store.refusal.lotShort': 'პარტიაში ამდენი აღარ არის — განაახლე სია და სცადე თავიდან',
  'store.refusal.lotDate': 'მიუთითე ვარგისიანობის თარიღი',
  'store.x.71': 'გადახდის შენახვა ვერ მოხერხდა',
  'store.x.72': 'აქციის შენახვა ვერ მოხერხდა',
  'store.x.73': 'აქციის პროდუქტების შენახვა ვერ მოხერხდა',
  'store.x.74': 'აქციის განახლება ვერ მოხერხდა',
  'store.x.75': 'აქციის წაშლა ვერ მოხერხდა',
  'store.x.76': 'აირჩიე მყიდველი',
  'store.x.77': 'დაბრუნებაზე ინვოისი არ გაიცემა',
  'store.x.78': 'ინვოისი ვერ გაიცა',
  'store.x.79': 'ეს PIN უკვე გამოიყენება სხვა აქტიურ მოლარეზე',
  'store.x.80': 'მოლარის დამატება ვერ მოხერხდა',
  'store.x.81': 'მოლარის განახლება ვერ მოხერხდა',
  'store.x.82': 'მოლარის წაშლა ვერ მოხერხდა',
  'store.x.83': 'ხარჯის დამატება ვერ მოხერხდა',
  'store.x.84': 'ხარჯი დაფიქსირდა',
  'store.x.85': 'ხარჯის წაშლა ვერ მოხერხდა',
  'store.x.86': 'ინტერნეტი არ არის — ყოველთვიური ხარჯი მხოლოდ ინტერნეტით ინახება',
  'store.x.87': 'ყოველთვიური ხარჯი ვერ შეინახა',
  'store.x.88': 'გამოტოვება ვერ მოხერხდა',
  'store.x.89': 'ხარჯი ვერ ჩაიწერა',
  'store.x.90': 'ყოველთვიური ხარჯი ვერ წაიშალა',
  'store.x.91': 'ფისკალური სტატუსის შენახვა ვერ მოხერხდა',
  'store.rec.amount': 'თანხა არასწორია — 0-ზე მეტი, მაქსიმუმ ₾1 000 000, თეთრი ორი ციფრით',
  'store.rec.category': 'აირჩიე ხარჯის სახე',
  'store.rec.day': 'თვის რიცხვი — 1-დან 31-მდე',
  'store.rec.mode': 'აირჩიე: თანხა ყოველ თვე ერთია თუ იცვლება',
  'store.rec.tin': 'ს/კ ძალიან გრძელია — მაქსიმუმ 20 სიმბოლო',
  'store.rec.branch': 'ფილიალი ვერ მოიძებნა — გვერდი განაახლე',
  'store.rec.notFound': 'ეს ყოველთვიური ხარჯი უკვე წაშლილია — სია განახლდა',
  'store.rec.notDue': 'ამ თვის თანხა უკვე ჩაწერილია — სია განახლდა',
  'store.rec.notOwner': 'ყოველთვიურ ხარჯებს მხოლოდ მაღაზიის მფლობელი ცვლის',
  'store.x.sourceOnly': '{name} — წყარო ფილიალში მხოლოდ {n} ცალია',
  'store.bd.done': '{source_name} დაიშალა — {n} ნაწილი',
  'store.bd.exceeds': 'ნაწილები ({parts}) წყაროზე ({source}) მეტს იწონის',
  'store.bd.duplicate': 'ერთი და იგივე ნაწილი ორჯერაა სიაში',
  'store.bd.service': 'მომსახურებას მარაგი არ აქვს — ის ვერ დაიშლება და ნაწილი ვერ იქნება',
  'store.bd.price': 'უარყოფითი ფასი — ჯერ პროდუქტის ფასი გაასწორე',
  'store.bd.tooMany': 'ერთ დაშლაში მაქსიმუმ 20 ნაწილია',
  'store.bd.noParts': 'დაამატე ერთი ნაწილი მაინც',
  'store.bd.ownerOnly': 'დაშლას მხოლოდ მფლობელი აკეთებს',
  'store.bd.refReused': 'ეს დაშლა უკვე სხვა მონაცემებითაა შენახული — ფანჯარა თავიდან გახსენი',
  'store.x.onlyInStock': '{name} — მარაგშია მხოლოდ {n}',
  // lib/loss-control — the events tab's and the attention rail's words
  'loss.kind.line': 'კალათიდან ამოიღეს',
  'loss.kind.qty': 'რაოდენობა შეამცირეს',
  'loss.kind.clear': 'კალათა გასუფთავდა',
  'loss.kind.held': 'გადადებული კალათა წაიშალა',
  'loss.kind.replaced': 'კალათა გადადებულით ჩაანაცვლეს',
  'loss.products': '{n} პროდუქტი',
  'loss.wholesale': 'საბითუმო',
  'loss.priceChanged': 'ფასი შეიცვალა',
  'loss.role.owner': 'მფლობელის ანგარიშით',
  'loss.role.cashier': 'მოლარის ანგარიშით',
  'loss.role.accountant': 'ბუღალტრის ანგარიშით',
  'loss.role.support': 'მხარდაჭერა',
  'loss.system': 'სისტემა',
  'loss.onShift': '{login} · ცვლა: {name}',
  'loss.noShift': 'ცვლის გარეშე',
  // lib/recurring-expenses
  'rec.everyLast': 'ყოველი თვის ბოლო დღეს',
  'rec.everyDay': 'ყოველი თვის {day} რიცხვში',
  // lib/fiscal — the printer's refusals, shown on the till and in the history
  'fiscal.err.noLink': 'ფისკალურ აპარატთან კავშირი ვერ დამყარდა (ErpNet.FP გაშვებულია?)',
  'fiscal.err.status': 'ფისკალურმა აპარატმა დააბრუნა შეცდომა ({status})',
  'fiscal.err.rejected': 'ფისკალურმა აპარატმა ოპერაცია უარყო',
  'fiscal.err.list': 'აპარატების სია ვერ წამოვიდა ({status})',
  'fiscal.err.none': 'ფისკალური აპარატი ვერ მოიძებნა',
  'fiscal.err.notConfigured': 'ფისკალური აპარატი არ არის კონფიგურირებული',
  'fiscal.err.noNumber': 'აპარატმა ჩეკის ნომერი არ დააბრუნა',
  'fiscal.err.noReturnNumber': 'აპარატმა დაბრუნების ჩეკის ნომერი არ დააბრუნა',
  // lib/waybill-out — validateDraft's problems on the screen (the server keeps `message`)
  'wbp.buyerTin': 'მყიდველის საიდენტიფიკაციო კოდი 9 ან 11 ციფრია',
  'wbp.buyerName': 'მყიდველის დასახელება სავალდებულოა',
  'wbp.startAddress': 'გასვლის მისამართი სავალდებულოა',
  'wbp.endAddress': 'ჩაბარების მისამართი სავალდებულოა',
  'wbp.beginDate': 'ტრანსპორტირების დაწყების დრო სავალდებულოა',
  'wbp.carNumber': 'ავტომობილის ნომერი არასწორია',
  'wbp.driverTin': 'მძღოლის პირადი ნომერი 9 ან 11 ციფრია',
  'wbp.carMissing': 'საავტომობილო გადაზიდვას ავტომობილის ნომერი სჭირდება',
  'wbp.driverMissing': 'საავტომობილო გადაზიდვას მძღოლის პირადი ნომერი სჭირდება',
  'wbp.lines': 'ზედნადები ცარიელია',
  'wbp.lineName': 'დასახელება სავალდებულოა',
  'wbp.lineQty': 'რაოდენობა ნულზე მეტი უნდა იყოს',
  'wbp.linePrice': 'ფასი უარყოფითი ვერ იქნება',
  // lib/drawer-text outflowText — drawerOutflows' rows on screen (OUTFLOW_LABELS stays for the mail)
  'outflow.owner': 'მფლობელს',
  'outflow.bank': 'ბანკში — {bank}',
  'outflow.bankUnnamed': 'ბანკში — ბანკი არ არის მითითებული',
  'outflow.expense': 'ხარჯი (სალაროდან)',
  'outflow.salary': 'ხელფასი (ცვლის დახურვისას)',
  'outflow.purchase': 'მომწოდებელს (მიღებისას)',
  'outflow.other': 'სხვა',
  'store.codes.offline': 'კოდის მისაბმელად ინტერნეტი საჭიროა',
  'store.codes.taken': 'კოდი {code} უკვე აქვს: {name}',
  'store.codes.takenElsewhere': 'ეს კოდი უკვე სხვა პროდუქტს აქვს — სია განახლდა, სცადე ხელახლა',
  'store.codes.tooMany': 'პროდუქტს 10-ზე მეტი დამატებითი კოდი ვერ ექნება',
  'store.codes.failed': 'კოდი ვერ მიება',
} as const
